<article class="indication-card">

    <section class="indication-card__time">
        <ci-circular-progress [value]="progress()" width="58"></ci-circular-progress>

        <div class="indication-card__time__icon" [class.success]="isSuccess()">
            <ci-icon class="indication-card__time__icon__progress" type="svg" [name]="getMappedSign()"></ci-icon>
        </div>

        @if(!isSuccess()){
            <div class="indication-card__time__info">
                <span class="ci-paragraph-p3-semibold">{{ timeRemaining() }}</span>
                @if(timeRemaining() > 1){
                    <span class="ci-caption-regular">{{ 'minutos' | translate }}</span>
                } @else {
                    <span class="ci-caption-regular">{{ 'minuto' | translate }}</span>
                }
            </div>
        }
    </section>

    <section class="indication-card__instructions">
        <div class="indication-card__instructions__info">
            @if(isSuccess()){
                <h3 class="ci-caption-semibold success">{{ '!Enhorabuena!' | translate }}</h3>
            }
            @else {
                <h3 class="ci-caption-semibold">{{ label() | translate }}</h3>
            }
            <span class="ci-paragraph-p1-regular">{{intructions()}}</span>
        </div>
        @if(isSuccess() && nextItem()){
            <div class="indication-card__instructions__next-item">
                <span class="ci-caption-semibold">{{ 'Próximo destino' | translate }}:</span>
                <span class="ci-caption-regular">{{ nextItem() }}</span>
            </div>
        }
    </section>
</article>